import React, {useEffect, useState} from "react";
import {
    IonButton,
    IonCol,
    IonContent, IonFooter,
    IonGrid,
    IonHeader,
    IonItem,
    IonLabel, IonLoading,
    IonRow,
    IonTabButton,
    IonToolbar
} from "@ionic/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Text from "../CommonStyles/Text";
import {Link, useNavigate} from "react-router-dom";
import './ioncontent.css';
import {Logo} from "../../components/Icons/Logo";


const WelcomePage = ({storeData, eventcode, auctioncode}) => {
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        if (storeData?.storelandinghtml?.length > 0 || storeData?.status === 'expired') {
            setIsLoading(false)
        }
        else {
            setIsLoading(true)
        }

        return () => {
            setIsLoading(false)
        }
    }, [storeData])

    return (
        <>
            <IonLoading isOpen={isLoading}/>
            <div style={{display: isLoading ? 'none' : '', backgroundColor: 'transparent', height: '100%'}}>
                {/*<IonContent >*/}
                    <IonHeader>
                        {storeData?.status === 'expired' &&
                            <>
                            <IonRow style={{marginTop: "20px", marginBottom: "40px", display: "flex-center", alignItems: 'center', justifyContent: 'center' }}>
                                <Logo width={'350px'}/>
                            </IonRow>

                            <IonRow>
                                <IonCol style={{ margin: '20px', display: "flex-center", alignItems: 'center', justifyContent: 'center' }}>
                                    <Text textAlign="center">
                                        {storeData?.message}
                                    </Text>
                                </IonCol>
                            </IonRow>
                            </>
                        }
                        {(storeData?.status === 'success') &&
                            <IonRow>
                                <IonCol style={{ margin: '20px', display: "flex-center", alignItems: 'center', justifyContent: 'center', backgroundColor: 'transparent' }}>
                                    <Text textAlign="center">
                                        <div dangerouslySetInnerHTML={{ __html: storeData?.storelandinghtml }} />
                                    </Text>
                                </IonCol>
                            </IonRow>
                        }

                    </IonHeader>

                    <IonFooter style={{backgroundColor: 'transparent', paddingBottom: '80px'}}>
                        <Text textAlign="center">
                            <div dangerouslySetInnerHTML={{ __html: storeData?.torewelcomefooter }} />
                        </Text>
                        <div style={{width: '75%', margin: 'auto', borderTop: "1px solid #666", marginTop: '50px', backgroundColor: 'transparent'}}>
                            <div style={{verticalAlign: 'middle', color: '#666', marginTop: '5px', marginBottom: "0px", backgroundColor: 'transparent', position: "relative", padding:"0 0 0 0", textAlign: "center", fontSize: 12}}>
                                EventSnap™. All Rights Reserved by DonorSnap.{" "}<br />
                                <span style={{ color: "red" }}>
                            <a><Link style={{ textDecoration: 'none' }} to={"/" + eventcode + "/privacy-policy"}>Privacy Policy</Link></a>
                          </span>
                            </div>
                        </div>
                    </IonFooter>
                {/*</IonContent>*/}
                <IonGrid style={{'border-style': 'solid;'}}>
                    <IonRow  size-md="12" size-sm="12" class={'ion-justify-content-center ion-align-items-center'} style={{bottom: 0, zIndex: 10000, position: 'fixed', backgroundColor: '#f2f2f2', width: '100%'}}>
                        {storeData?.storewelcomebuttoneventshow &&
                            <div className="ion-float-md-left ion-padding">
                                <IonCol size-md="6" size-sm="12">
                                    {/*<IonItem lines={'none'} >*/}
                                        <IonButton size-md="12" size-sm="12" onClick={() => { navigate('/' + eventcode + '/event/register')}}
                                                   style={{marginLeft: 'auto',  fontSize: '18px', height: '40px'}} color={'primary'}>
                                            {storeData?.storewelcomebuttonevent}
                                        </IonButton>
                                    {/*</IonItem>*/}
                                </IonCol>
                            </div>
                        }

                        {storeData?.storewelcomebuttonauctionshow &&
                            <div className="ion-float-md-right ion-padding">
                                <IonCol size-md="6" size-sm="12">
                                    {/*<IonItem lines={'none'} >*/}
                                        <IonButton size-sm="12" href={storeData?.storewelcomeauctionlink}  id="notification-button" style={{fontSize: '18px', height: '40px'}} color={'primary'}>
                                            {storeData?.storewelcomebuttonauction}
                                        </IonButton>
                                    {/*</IonItem>*/}
                                </IonCol>
                            </div>
                        }
                    </IonRow>
                </IonGrid>
            </div>
        </>
    )
}

export default WelcomePage